import { type Images } from '@neos/app'
import alertTrianglePath from '../../modules/TMSCpoOpsTackingBusiness/images/AlertTriangle.svg'
import arrowLeftPath from '../../modules/TMSCpoOpsTackingBusiness/images/ArrowLeft.svg'
import checkCirclePath from '../../modules/TMSCpoOpsTackingBusiness/images/CheckCircle.svg'
import closePath from '../../modules/TMSCpoOpsTackingBusiness/images/Close.svg'
import deliveryPath from '../../modules/TMSCpoOpsTackingBusiness/images/Delivery.svg'
import documentPath from '../../modules/TMSCpoOpsTackingBusiness/images/Document.svg'
import loadingPath from '../../modules/TMSCpoOpsTackingBusiness/images/Loading.svg'
import phonePath from '../../modules/TMSCpoOpsTackingBusiness/images/Phone.svg'
import showPath from '../../modules/TMSCpoOpsTackingBusiness/images/Show.svg'
import uploadPath from '../../modules/TMSCpoOpsTackingBusiness/images/Upload.svg'

const images: Images = {
  alertTriangle: { path: alertTrianglePath, colored: false },
  arrowLeft: { path: arrowLeftPath, colored: true },
  checkCircle: { path: checkCirclePath, colored: false },
  close: { path: closePath, colored: true },
  delivery: { path: deliveryPath, colored: false },
  document: { path: documentPath, colored: false },
  loading: { path: loadingPath, colored: false },
  phone: { path: phonePath, colored: false },
  search: 'search',
  show: { path: showPath, colored: false },
  upload: { path: uploadPath, colored: false },
}

export default images